import { useEffect, useRef, useState } from 'react';
import { downloadContent } from '../services/contentService';
import {
  DocumentPreviewState,
  INITIAL_DOCUMENT_PREVIEW_STATE,
  getPreviewKind,
} from '../utils/documentPreview';

/**
 * Estado + fetch compartilhados pela visualização de documento em modal
 * (PDF/imagem, sem download prévio - E5). Reaproveita o mesmo
 * downloadContent já usado pelo botão "Baixar" de sempre; a única
 * diferença é o que se faz com o blob depois de baixado.
 *
 * Cada tela continua responsável pelo próprio tratamento de erro
 * (try/catch ao redor de openPreview, igual já fazem para o download).
 */
export const useDocumentPreview = () => {
  const [previewState, setPreviewState] = useState<DocumentPreviewState>(
    INITIAL_DOCUMENT_PREVIEW_STATE
  );
  const urlRef = useRef<string | null>(null);

  // Libera a última URL de objeto ao desmontar - evita vazar memória se o
  // usuário sair da tela com o modal aberto.
  useEffect(() => {
    return () => {
      if (urlRef.current) {
        window.URL.revokeObjectURL(urlRef.current);
      }
    };
  }, []);

  const openPreview = async (content: { id: number; description: string }) => {
    const kind = getPreviewKind(content.description);
    if (!kind) return;

    const response = await downloadContent(content.id);
    const url = window.URL.createObjectURL(response.data);

    if (urlRef.current) {
      window.URL.revokeObjectURL(urlRef.current);
    }
    urlRef.current = url;

    setPreviewState({ show: true, url, kind, title: content.description });
  };

  const closePreview = () => {
    if (urlRef.current) {
      window.URL.revokeObjectURL(urlRef.current);
      urlRef.current = null;
    }
    setPreviewState(INITIAL_DOCUMENT_PREVIEW_STATE);
  };

  return { previewState, openPreview, closePreview };
};
